<ng-select [items]="materials | async"
           [(ngModel)]="material">
</ng-select>
